import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  background-image: url('/images/welcome.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-position-x: 58%;
  background-position-y: 110%;
`;

export const LogoContainer = styled.div`
  margin-top: 27px;
  height: 27px;
  width: 75px;
  > img {
    height: 100%;
  }
`;

export const Title = styled.h1`
  font-family: Poppins;
  font-size: 32px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.OrangeSoda};
  margin-top: 53px;
`;

export const Description = styled.label`
  margin-top: 46px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.CharlestonGreen};
  padding: 0;
`;

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 32px;
`;

export const ContainerDesktop: any = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  min-width: 100vh;
  position: relative;
  background-position: right;
  background-repeat: no-repeat;
  background-color: ${ColorPalette.HEX.White};
`;

ContainerDesktop.Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${ColorPalette.HEX.White};
  padding: 64px;
`;

ContainerDesktop.ColumnImage = styled.div`
  width: 100%;
  background-color: ${ColorPalette.HEX.GhostWhite};
  background-image: url('/images/welcome-desktop.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 277px;
  border-left: 1px solid ${ColorPalette.HEX.BrightGray};
`;

export const IconArea: any = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

IconArea.Logo = styled.img`
  width: 144px;
  height: 74px;
`;

export const ContentDesktop = styled.div`
  margin: auto;
`;

export const TitleDesktop = styled.div`
  font-family: Poppins;
  font-size: 40px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: -0.4px;
  color: ${ColorPalette.HEX.OrangeSoda};
`;

export const DescriptionDesktop = styled.div`
  margin-top: 40px;
  font-family: Poppins;
  font-size: 32px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const ButtonContainerDesktop = styled.div`
  margin-top: 155px;
  max-width: 343px;

  @media ${({ theme }) => theme.device.mobile} {
    padding-bottom: 233px;
  }
`;
